import React from 'react';
import { Button } from './ui/button';
import { useNavigate } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import { useLang } from '../context/LanguageContext';

export default function NotFound() {
  const navigate = useNavigate();
  const { t } = useLang();

  return (
    <>
      <Header />
      <main className="bg-white min-h-[70vh] flex items-center justify-center px-6 pt-24" data-testid="not-found-page">
        <div className="text-center max-w-lg">
          <p className="text-7xl font-semibold text-[#0071E3] mb-4">404</p>
          <h1 className="text-3xl md:text-4xl font-semibold text-[#1D1D1F] mb-4 tracking-tight">
            {t('notFound.title')}
          </h1>
          <p className="text-[#86868B] mb-8">
            {t('notFound.text')}
          </p>
          <Button
            onClick={() => navigate('/')}
            className="bg-[#0071E3] hover:bg-[#0077ED] text-white rounded-full h-12 px-8"
            data-testid="not-found-home-button"
          >
            {t('notFound.home')}
          </Button>
        </div>
      </main>
      <Footer />
    </>
  );
}
